export const MobileBreakpoint = {
  Max1439: '(max-width:1439px)',
  Max1023: '(max-width:1023px)',
  Max767: '(max-width:767px)',
  Min768: '(min-width:768px)',
};

//TODO this naming is not correct: this function in general match any of the query above
export const isMobile = function(breakpoint) {
  return window.matchMedia(breakpoint).matches;
};

export const isBreakpoint = function(breakpoint) {
  return window.matchMedia(breakpoint).matches;
};

export const isTablet = function() {
  return isBreakpoint(MobileBreakpoint.Max1023) && isBreakpoint(MobileBreakpoint.Min768);
};
